import React from 'react';
import cn from 'classnames';
import { NUVIU_APP_STORE_LINK } from '../../constants';
import { AppleIcon } from '../../icons';
import { CustomButton } from '../index';
import styles from './AppStoreButton.module.scss';

const AppStoreButton = ({ className = '' }) => {
  return (
    <CustomButton
      className={cn(styles.appStoreButton, className)}
      onClick={() => window.open(NUVIU_APP_STORE_LINK)}
    >
      <AppleIcon className={styles.appStoreButtonIcon} />
      App Store
    </CustomButton>
  );
};

export default AppStoreButton;
